/**
 * This file contains utility functions for handling content packages.
 */

import moment from "moment";

/**
 * @typedef {{ ContentPackageId: number, PublicationDate: string, ContentPackagePublishTime: string }} ContentPackage
 */

/**
 * Comparison logic for sorting content packages based on their publication date, publishing time and ID in descending order.
 *
 * @param {ContentPackage} cp1 - The first content package to compare.
 * @param {ContentPackage} cp2 - The second content package to compare.
 * @returns {number} A negative number if cp1 should come before cp2, a positive number if cp1 should come after cp2, and 0 if they are equal.
 */
export const contentPackagesByDescendingOrderComparison = (cp1, cp2) => {
  // We first compare the publication dates
  const publicationDateOfCp1 = moment(cp1.PublicationDate);
  const publicationDateOfCp2 = moment(cp2.PublicationDate);
  if (!publicationDateOfCp1.isSame(publicationDateOfCp2)) {
    return publicationDateOfCp2 - publicationDateOfCp1;
  }

  // If the publication dates are the same, we compare the publishing times
  const publishingTimeOfCp1 = moment(cp1.ContentPackagePublishTime);
  const publishingTimeOfCp2 = moment(cp2.ContentPackagePublishTime);
  if (!publishingTimeOfCp1.isSame(publishingTimeOfCp2)) {
    return publishingTimeOfCp2 - publishingTimeOfCp1;
  }

  // If both publication date and publishing time are the same, we compare the content packages IDs
  return cp2.ContentPackageId - cp1.ContentPackageId;
};



// WEBPACK FOOTER //
// ./src/common/utilities/contentPackages.utils.js